module.exports = __webpack_public_path__ + "img/google-ar-2x.1f438c16.png";